import { useMemo } from 'react';

import { mapPublicAnalysisCategoryToAnalysisCategoryItem } from '@/shared/api/mappers/analysis';
import { useGetPublicAnalysisCategoriesQuery } from '@/shared/hooks/queries/generated';

export const usePublicAnalysisMenuListData = () => {
  const {
    data: publicAnalysesData,
    isLoading: isLoadingPublicAnalyses,
    error: publicAnalysesError,
    refetch: refetchPublicAnalyses,
  } = useGetPublicAnalysisCategoriesQuery(
    {},
    {
      queryKey: ['GetPublicAnalysisCategories'],
    },
  );

  const categories = useMemo(() => {
    const publicAnalyses = publicAnalysesData?.getPublicAnalysisCategories || [];

    // Mapper vers le format frontend
    return publicAnalyses.map(mapPublicAnalysisCategoryToAnalysisCategoryItem);
  }, [publicAnalysesData]);

  const loading = isLoadingPublicAnalyses;
  const error = publicAnalysesError;

  const refetch = () => {
    refetchPublicAnalyses();
  };

  return {
    categories,
    loading,
    error: error ? 'Erreur lors du chargement des analyses' : null,
    refetch,
  };
};
